export default "/images/move.svg?835cfd943edfecb6064f6d6b0447f703";